import { render } from "./CreateSimilarTestModal.vue?vue&type=template&id=6a23f176&scoped=true"
import script from "./CreateSimilarTestModal.vue?vue&type=script&lang=js"
export * from "./CreateSimilarTestModal.vue?vue&type=script&lang=js"

import "./CreateSimilarTestModal.vue?vue&type=style&index=0&id=6a23f176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a23f176"]])

export default __exports__